module.exports = __webpack_public_path__ + "3c5e4f4307b86963235ac7b04f74d500.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/162.png
// module id = 1757
// module chunks = 2